const GET_AZURE_METRICS_REQUEST = "GET_AZURE_METRICS_REQUEST";
const GET_AZURE_METRICS_REQUEST_SUCCESS = "GET_AZURE_METRICS_REQUEST_SUCCESS";
const GET_AZURE_METRICS_REQUEST_ERROR = "GET_AZURE_METRICS_REQUEST_ERROR";

export {
  GET_AZURE_METRICS_REQUEST,
  GET_AZURE_METRICS_REQUEST_SUCCESS,
  GET_AZURE_METRICS_REQUEST_ERROR,
};
